/* eslint-disable max-len */
import {
  useTranslate,
  FunctionField,
  useList,
  ListContextProvider,
  useShowContext
} from "react-admin";
import CustomDataGrid from "./CustomDataGrid";

export default function OrderServicesAndItemsList({
  data,
  isLoading,
  price,
  totalDiscount
}: {
  data: any;
  isLoading: boolean;
  price: number;
  totalDiscount: number;
}) {
  const translate = useTranslate();
  const { record } = useShowContext();

  const listContext = useList({ data, isLoading });

  const transactionUserPaysFees = record?.transactions.find(
    (t: any) => t.user_pays_fees
  );

  const totalTipAmount = record?.transactions?.reduce(
    (acc: number, curr: any) => {
      if (curr.status === "SUCCESS") {
        acc += curr?.total_tip_amount;
      }
      return acc;
    },
    0
  );

  const userPaysFees = transactionUserPaysFees
    ? true
    : record?.location?.company?.user_pays_fees;

  let totalPrice = price;
  let taxAndFees = 0;

  if (userPaysFees) {
    taxAndFees = Number(
      ((price + totalTipAmount - totalDiscount) * 0.04).toFixed(2)
    );
    totalPrice = Number((price + totalTipAmount + taxAndFees).toFixed(2));
  }

  return (
    <div className="relative">
      <ListContextProvider value={listContext}>
        <CustomDataGrid
          rowClick={false}
          hover={false}
          sx={{
            borderRadius: "0px",
            ".RaDatagrid-headerCell": {
              backgroundColor: "transparent",
              minWidth: "0px",
              fontSize: "14px",
              "@media screen and (max-width:1280px)": {
                fontSize: "12px"
              },
              "@media screen and (max-width:640px)": {
                paddingLeft: "4px",
                paddingRight: "4px"
              }
            },
            ".RaDatagrid-rowCell": {
              minWidth: "0px",
              "@media screen and (max-width:640px)": {
                paddingLeft: "4px",
                paddingRight: "4px"
              }
            },
            ".RaDatagrid-rowCell span": {
              fontSize: "14px",
              "@media screen and (max-width:1280px)": {
                fontSize: "12px"
              }
            }
          }}
        >
          <FunctionField
            label={
              <span className="line-clamp-1 break-all">
                {translate("order.item")}
              </span>
            }
            render={(record: any) => {
              const name = record?.service?.name || record?.addon?.name;
              const description =
                record?.service?.description ||
                record?.addon?.description ||
                record?.description;
              return (
                <div className="line-clamp-1 break-all">
                  {name || description}
                </div>
              );
            }}
          />
          <FunctionField
            label={translate("order.type")}
            textAlign="right"
            render={(record: any) => (
              <div>
                {record?.type === "Service" && translate("order.service")}
                {record?.type === "Addon" && translate("order.addon")}
                {record?.type === "Freeform" && translate("order.freeform")}
              </div>
            )}
          />
          <FunctionField
            label={translate("order.quantity")}
            textAlign="right"
            render={(record: any) => <div>{record?.quantity}</div>}
          />
          <FunctionField
            label={
              <span className="line-clamp-1 break-all">
                {translate("order.amount")}
              </span>
            }
            textAlign="right"
            render={(record: any) => (
              <div>
                {record?.quantity > 1
                  ? `$${record?.price * record?.quantity}`
                  : record?.price > 0
                  ? `$${record?.price}`
                  : `-$${Math.abs(record?.price)}`}
              </div>
            )}
          />
        </CustomDataGrid>
        <div className="w-full flex justify-end px-1 md:px-4 border-t border-[#e0e0e0] gap-[16px] text-[14px] font-['Inter'] font-[400] leading-[143%]">
          <div className="text-right mt-4">
            <div>{translate("order.subtotal")}:</div>
            <div>{translate("order.discount")}:</div>
            <div>{translate("order.tip_amount")}:</div>
            <div>
              {translate("order.tax_and_fees")} ({userPaysFees ? 4 : 0}%):
            </div>
            <div className="font-[700] mt-4 mb-1">
              {translate("order.total")}:
            </div>
          </div>
          <div className="text-right mt-4">
            <div>${price.toFixed(2)}</div>
            <div>-${totalDiscount.toFixed(2)}</div>
            <div>+${totalTipAmount.toFixed(2)}</div>
            <div>+${taxAndFees.toFixed(2)}</div>
            <div className="font-[700] mt-4 mb-1">
              $
              {Number((totalPrice - totalDiscount).toFixed(2)) > 0
                ? (totalPrice - totalDiscount).toFixed(2)
                : 0}
            </div>
          </div>
        </div>
      </ListContextProvider>
      <div className="absolute bottom-[30px] w-full h-[1px] bg-mono-black" />
    </div>
  );
}
